import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectNewbuildingsCompareBlocks, selectNewbuildingsComparison } from '../../selectors/newbuildingsCompare';
import { NewbuildingsComparePage } from '../../components/NewbuildingsComparePage';
import { Cell } from '../../components/NewbuildingsComparePage/parts/Cell';
import { AiBannerContainer } from '../AiBanner';
import { buildNewbuildingsCompareViewRows } from './buildViewRows';

export const NewbuildingsComparePageContainer = () => {
  const comparison = useSelector(selectNewbuildingsComparison);
  const blocks = useSelector(selectNewbuildingsCompareBlocks);
  const [isRoomStatsExpanded, setRoomStatsExpanded] = React.useState(false);

  const handleToggleRoomStats = React.useCallback(() => setRoomStatsExpanded(value => !value), []);

  const { rows: tableRows, summaryRow } = buildNewbuildingsCompareViewRows({
    blocks,
    platform: 'desktop',
    isRoomStatsExpanded,
    onToggleRoomStats: handleToggleRoomStats,
    showDeveloperLinkRow: true,
  });

  if (!comparison) {
    return null;
  }

  const headers = [
    <AiBannerContainer key="ai-banner" />,
    ...(summaryRow?.cells.map((cell, index) => <Cell cell={cell} key={index} type={summaryRow.type} />) ?? []),
  ];
  const floatingHeaders = [
    '',
    ...(summaryRow?.cells.map((cell, index) => <Cell cell={cell} floating key={index} type={summaryRow.type} />) ?? []),
  ];

  return (
    <NewbuildingsComparePage
      floatingHeaders={floatingHeaders}
      headers={headers}
      rows={tableRows}
      title={comparison.title}
    />
  );
};
